module.exports = __webpack_public_path__ + "static/media/logo-mano-mano.db5eb04b.png";